export default __webpack_public_path__ + "static/media/Pavlov.f5967121.svg";